module.exports = __webpack_public_path__ + "b0e5c618380a630813f0b0d3dda56906.MP3";